import angular from 'angular';

import DetailsDialogComponent from './details-dialog.component';
import { DetailsDialogController } from './details-dialog.controller';

export default angular
  .module('details-dialog', [])
  .controller('DetailsDialogController', DetailsDialogController)
  .component('detailsDialog', DetailsDialogComponent);



// WEBPACK FOOTER //
// ./src/modules/manage-inventory/components/details-dialog/details-dialog.module.js